import * as types from "./actionTypes.js";
import * as assignmentApi from '../../api/assignmentApi.js';

export function fetchCostObjects(parameters) {
  return function(dispatch) {
    return assignmentApi
      .getCostObjects(parameters)
      .then(costObjects => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_COST_OBJECTS_SUCCESS,
          costObjects
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchRelevantJobs(startTime, userId) {
  return function(dispatch) {
    return assignmentApi
      .getRelevantJobs(startTime, userId)
      .then(relevantJobs => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_RELEVANT_JOBS_SUCCESS,
          relevantJobs
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchRelevantJobsForCostObject(startTime, userId, costObjectId, costObjectTypeId) {
  return function(dispatch) {
    return assignmentApi
      .getRelevantJobsForCostObject(startTime, userId, costObjectId, costObjectTypeId)
      .then(relevantJobsForCostObject => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_RELEVANT_JOBS_FOR_COST_OBJECT_SUCCESS,
          relevantJobsForCostObject
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchRelatedBranches(userId) {
  return function(dispatch) {
    return assignmentApi
      .getRelatedBranches(userId)
      .then(relatedBranches => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_RELATED_BRANCHES_SUCCESS,
          relatedBranches
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchGroupsByBranchAndResource(branchId, resourceId) {
  return function(dispatch) {
    return assignmentApi
      .getGroupsByBranchAndResource(branchId, resourceId)
      .then(groupsByBranchAndResource => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_GROUPS_BY_BRANCH_AND_RESOURCE_SUCCESS,
          groupsByBranchAndResource
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchServicesByDate(branchId, resourceId, startTime, endTime, priceMethodId, groupId, timeZoneId) {
  return function(dispatch) {
    return assignmentApi
      .getServicesByDate(branchId, resourceId, startTime, endTime, priceMethodId, groupId, timeZoneId)
      .then(servicesByDate => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_SERVICES_BY_DATE_SUCCESS,
          servicesByDate
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchActivityTypes(relatedServiceId, referenceDate) {
  return function(dispatch) {
    return assignmentApi
      .getActivityTypes(relatedServiceId, referenceDate)
      .then(activityTypes => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_ACTIVITY_TYPES_SUCCESS,
          activityTypes
        });
      })
      .catch(error => {
        throw error;
      });
  };
}


export function fetchServiceSalaryLevel(serviceId) {
  return function(dispatch) {
    return assignmentApi
      .getServiceSalaryLevel(serviceId)
      .then(serviceSalaryLevel => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_SERVICE_SALARY_LEVEL_SUCCESS,
          serviceSalaryLevel
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchServicePrimaryRate(serviceId) {
  return function(dispatch) {
    return assignmentApi
      .getServicePrimaryRate(serviceId)
      .then(servicePrimaryRate => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_SERVICE_PRIMARY_RATE_SUCCESS,
          servicePrimaryRate
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchJobSalariesByService(serviceId, startTime) {
  return function(dispatch) {
    return assignmentApi
      .getJobSalariesByService(serviceId, startTime)
      .then(serviceJobSalaries => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_JOB_SALARIES_BY_SERVICE_SUCCESS,
          serviceJobSalaries
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function logJobStart(userId, operation) {
  return function(dispatch) {
    return assignmentApi
      .logJobStart(userId, operation)
      .then(logJobStartRecord => {
        // separate action creator for successfull api call
        dispatch({
          type: types.LOG_JOB_START_SUCCESS,
          logJobStartRecord
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function logJobFinish(logControlId, jobId) {
  return function(dispatch) {
    return assignmentApi
      .logJobFinish(logControlId, jobId)
      .then(logJobFinishRecord => {
        // separate action creator for successfull api call
        dispatch({
          type: types.LOG_JOB_FINISH_SUCESS,
          logJobFinishRecord
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function addJob(parameters) {
  return function(dispatch) {
    return assignmentApi
      .createJob(parameters)
      .then(job => {
        // separate action creator for successfull api call
        dispatch({
          type: types.ADD_JOB_SUCCESS,
          job
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function addJobElement(parameters) {
  return function(dispatch) {
    return assignmentApi
      .createJobElement(parameters)
      .then(jobElement => {
        // separate action creator for successfull api call
        dispatch({
          type: types.ADD_JOB_ELEMENT_SUCCESS,
          jobElement
        });
      })
      .catch(error => {
        throw error;
      });
  };
}

export function fetchValidateEmptyJob(assignmentId) {
  return function (dispatch) {
      return assignmentApi
          .getValidateEmptyJob(assignmentId)
          .then(response => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_VALIDATE_EMPTY_JOB_SUCCESS,
                  response
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function removeJob(parameters) {
  return function (dispatch) {
      return assignmentApi
          .deleteJob(parameters)
          .then(response => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.REMOVE_JOB_SUCCESS,
                  response
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function removeJobElement(parameters) {
  return function (dispatch) {
      return assignmentApi
          .deleteJobElement(parameters)
          .then(response => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.REMOVE_JOB_ELEMENT_SUCCESS,
                  response
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchJob(jobId) {
  return function (dispatch) {
      return assignmentApi
          .getJob(jobId)
          .then(job => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_JOB_SUCCESS,
                  job
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchJobElement(jobElementId) {
  return function (dispatch) {
      return assignmentApi
          .getJobElement(jobElementId)
          .then(jobElement => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_JOB_ELEMENT_SUCCESS,
                  jobElement
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchCostObject(costObjectId, costObjectTypeId) {
  return function (dispatch) {
      return assignmentApi
          .getCostObject(costObjectId, costObjectTypeId)
          .then(costObject => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_COST_OBJECT_SUCCESS,
                  costObject
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchJobElementsWithDetails(jobId) {
  return function (dispatch) {
      return assignmentApi
          .getJobElementsWithDetails(jobId)
          .then(jobElementsWithDetails => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_JOB_ELEMENTS_WITH_DETAILS_SUCCESS,
                  jobElementsWithDetails
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchService(serviceId) {
  return function (dispatch) {
      return assignmentApi
          .getService(serviceId)
          .then(service => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_SERVICE_SUCCESS,
                  service
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchGroupsByBranchInCompany(branchId) {
  return function (dispatch) {
      return assignmentApi
          .getGroupsByBranchInCompany(branchId)
          .then(groupsByBranchInCompany => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_GROUPS_BY_BRANCH_IN_COMPANY_SUCCESS,
                  groupsByBranchInCompany
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchAssignmentServicesByGroup(groupId, serviceId) {
  return function (dispatch) {
      return assignmentApi
          .getAssignmentServicesByGroup(groupId, serviceId)
          .then(assignmentServicesByGroup => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_ASSIGNMENT_SERVICES_BY_GROUP_SUCCESS,
                  assignmentServicesByGroup
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchServicesByGroup(groupId, serviceId) {
  return function (dispatch) {
      return assignmentApi
          .getServicesByGroup(groupId, serviceId)
          .then(servicesByGroup => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_SERVICES_BY_GROUP_SUCCESS,
                  servicesByGroup
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function editJobElement(parameters) {
  return function(dispatch) {
      return assignmentApi
          .updateJobElement(parameters)
          .then(jobElement => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.EDIT_JOB_ELEMENT_SUCCESS,
                  jobElement
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchJobElements(jobId) {
  return function(dispatch) {
      return assignmentApi
          .getJobElements(jobId)
          .then(jobElements => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_JOB_ELEMENTS_SUCCESS,
                  jobElements
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function fetchApprovedJobElements(jobId) {
  return function(dispatch) {
      return assignmentApi
          .getApprovedJobElements(jobId)
          .then(approvedJobElements => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_APPROVED_JOB_ELEMENTS_SUCCESS,
                  approvedJobElements
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function editJob(parameters) {
  return function(dispatch) {
    return assignmentApi
      .updateJob(parameters)
      .then(job => {
        // separate action creator for successfull api call
        dispatch({
          type: types.EDIT_JOB_SUCCESS,
          job
        });
      })
      .catch(error => {
        throw error;
      });
  };
}
